export const KwanMobileFirst = () => {
    return (
        <div className="pt-[60px] pb-[20px] pl-[40px] [background:linear-gradient(135deg,rgba(250,231,237,1)_2.885%,rgba(82,160,252,1)_56.731%,rgba(59,224.75,254,1)_97.596%)] h-[390px]">
            <div className="w-[216px] bg-gradient-to-r from-[#619BFF] to-[rgba(198,225,255,0)] rounded-[4px] px-[4px] py-[4px] ">
                <div className=" font-bold text-[10px] text-[#FFFFFF]">
                    光年自建K-WAN组网解决方案
                </div>
            </div>
            <div className=" font-bold text-[10px] text-[#333333] mt-[4px]">
                光年K-WAN组网解决方案
            </div>
            <div className=" font-Regular text-[10px] text-[#333333] mt-[4px]">
                就近接入全球骨干网络，形成快速、稳定、合规的访问全球互联网资源加速专线，为出海企业提供优质的网络加速服务
            </div>
            <div className="w-[88px] h-[30px] bg-gradient-to-br from-[#5F97FF] to-[#0182FF] rounded-[4px] flex items-center justify-center mt-[6px]">
                <div className=" font-normal text-[12px] text-[#FFFFFF]">
                    立即咨询
                </div>
            </div>
            <div className="flex justify-center items-center">
                <img
                    className="w-[248px] min-w-[248px] h-[165px] mt-[11px]"
                    src={"/imgs/kwan/k-wan.png"}
                />
            </div>
        </div>
    );
};